import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModuleType } from '../../enums/allEnums';
import { ComponentImageHistoryComponent } from './component-image-history.component';

@Component({
  selector: 'app-component-image-history-button',
  templateUrl: './component-image-history-button.component.html',
  styleUrls: ['./component-image-history-button.component.scss']
})
export class ComponentImageHistoryButtonComponent {

  @Input() module!: ModuleType;
  @Input() equipmentId!: number;
  @Input() implementId!: number;
  @Input() componentId!: number;
  @Input() code!: string;
  @Input() imageHistoryAvailable: boolean;

  @Input() componentImages: any[] = [];

  constructor(private dialog: MatDialog) { }

  openPhoto() {
    this.dialog.open(ComponentImageHistoryComponent, {
      width: '1300px',
      panelClass: 'custom-dialog-panel',
      data: {
        module: this.module,
        equipmentId: this.equipmentId,
        implementId: this.implementId,
        componentId: this.componentId,
        code: this.code
      }
    });
  }
}
